import { Vue } from "vue-class-component";
import { BaseActionComponentProps } from "./BasActionComponentProps";

export default class BaseActionComponent extends Vue.with(BaseActionComponentProps) { }
